import { Box } from "@mui/material";
import { LoadingSpinner } from "@src/appV2/redesign/system/ui-components";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useWorkerIncome } from "../api/useWorkerIncome";
import { TaxInformationPageContent } from "./TaxInformationPageContent";

export function TaxInformationPageContentContainer(props: {
  taxationYear: number;
  formIssuanceThresholdInDollars: number;
  scrollRef?: React.RefObject<HTMLDivElement>;
}) {
  const { taxationYear, formIssuanceThresholdInDollars, scrollRef } = props;

  const worker = useDefinedWorker();
  const workerTimezone = worker.tmz;

  const { data: workerIncome, isLoading: isWorkerIncomeLoading } = useWorkerIncome({
    workerId: worker.userId,
    year: taxationYear,
  });

  const earnedAmountInDollars = workerIncome?.data.attributes.totalAmountInCents
    ? workerIncome.data.attributes.totalAmountInCents / 100
    : 0;

  return isWorkerIncomeLoading ? (
    <Box
      ref={scrollRef}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
      }}
    >
      <LoadingSpinner size="large" variant="primary" />
    </Box>
  ) : (
    <TaxInformationPageContent
      scrollRef={scrollRef}
      workerTimezone={workerTimezone}
      taxationYear={taxationYear}
      earnedAmountInDollars={earnedAmountInDollars}
      formIssuanceThresholdInDollars={formIssuanceThresholdInDollars}
    />
  );
}
